const loadGoogleMaps = () => {
    return new Promise((resolve, reject) => {
        if (typeof google !== "undefined" && google.maps?.Map) {
            return resolve();
        }

        const scriptId = "google-maps-script";
        const existingScript = document.getElementById(scriptId);

        const onReady = () => {
            // Wait for actual availability of Map constructor
            const interval = setInterval(() => {
                if (google?.maps?.Map) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);
        };

        if (existingScript) {
            console.warn("Google Maps script is already being loaded.");
            existingScript.addEventListener("load", onReady);
            return;
        }

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${site.constants["google-maps"].API_KEY}&loading=async&libraries=places,marker&v=beta`;
        script.async = true;
        script.defer = true;

        script.onload = onReady;
        script.onerror = () => {
            console.error("Failed to load Google Maps API");
            reject(new Error("Google Maps failed to load"));
        };

        document.body.appendChild(script);
    });
};
